/* eslint-disable */
import { Injectable } from '@angular/core';
import { LoggerService } from '../logger.service';
import { PosterService } from '../poster.service';
import { LoadService } from './load.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class ClearService {
  constructor(
    private logger: LoggerService,
    private poster: PosterService,
    private load: LoadService
  ) {}

  clearRadio(question, surveyData) {
    surveyData[question.name] = null;
    if (question.items) {
      question.items.forEach((item) => {
        if (item.subfield) {
          surveyData[item.subfield.name] = null;
        }
      });
    }
  }

  clearCheckbox(question, surveyData) {
    let i = 0;
    if (question.items) {
      question.items.forEach((item) => {
        surveyData[item.dbField] = null;
      });
    } else if (question.params && question.params.entryPerAForQ) {
      // TODO check server to see if this is ever called -
      //   loader creates items for this case (if above), and _CB_ prefix missing, so not sure this would even work
      // TODO - hook up poster
      this.logger.info('Clear cb elif called', MSRemoteLoggerCategory.SURVEY_CLEAR_SERVICE, question);
      for (; surveyData.hasOwnProperty(question.name + '_' + i); i++) {
        surveyData[question.name + '_' + i] = null;
      }
    }
  }

  clearGroup(question: any, surveyData: object, joiner = '_', start = 0, prefix = '') {
    let i = start;
    const max = question.params.maxEntries || 5; // TODO CONSTANT for default max entries
    for (; i < max; i++) {
      surveyData[prefix + question.name + joiner + i] = null;
    }
  }

  clearExtraAnswersForGroup(question: any, surveyData: object, joiner = '_', start = 0, prefix = '') {
    const max = question.params.maxEntries || 5; // TODO CONSTANT for default max entries
    const items = question.type === 'selects' ? question.questions : question.items;

    // cycle thru possible id's. if not included in items array, clear it
    // this clears items that had a response that were then hidden when re-answering
    for (let i = 0; i < max; i++) {
      const item = items.filter((item) => item.id === i);
      if (!item.length) {
        surveyData[prefix + question.name + joiner + i] = null;
      }
    }

    // let i = start,
    //     max = question.params.maxEntries || 5; // TODO CONSTANT for default max entries
    // for (; i < max; i++) {
    //     surveyData[prefix + question.name + joiner + i] = null;
    // }
  }

  clearVehicles(question, surveyData, start = 0) {
    this.clearGroup(question, surveyData, '_year_', start);
    this.clearGroup(question, surveyData, '_make_', start);
    this.clearGroup(question, surveyData, '_model_', start);
    this.clearGroup(question, surveyData, '_other_', start);
  }

  clearTransit(question, surveyData) {
    surveyData[question.name + '_agencyId'] = null;
    surveyData[question.name + '_routeId'] = null;
    surveyData[question.name + '_stopId'] = null;
  }

  clearVars(pageCopy, surveyData) {
    pageCopy.questions.forEach((question) => {
      //logger.log('Clearing ' + question.name);
      switch (question.type) {
        case 'radio':
        case 'button':
        case 'buttonBinary':
        case 'checkboxBinary':
        case 'confirm':
          this.clearRadio(question, surveyData);
          break;
        case 'checkbox':
          this.clearCheckbox(question, surveyData);
          break;
        case 'textarea':
        case 'textbox':
        case 'integer':
          surveyData[question.name] = null;
          break;
        case 'selects':
        case 'textboxes':
        case 'geocoders':
          this.clearGroup(question, surveyData);
          break;
        case 'vehicles':
          this.clearVehicles(question, surveyData);
          break;
        case 'transit':
          this.clearTransit(question, surveyData);
          break;
        default:
          break;
      }
    });
  }

  clearExtraAnswers(surveyType, pageName, surveyData) {
    if (-1 !== ['start', 'end'].indexOf(pageName)) {
      return Promise.resolve();
    }
    return this.load.getPageByName(surveyType, pageName, surveyData, null, null).then((page) =>
      page.questions.forEach((question) => {
        let firstInvalidId;
        let i;
        let field;
        let max;
        if (question.params && question.params.entryPerAForQ) {
          switch (question.type) {
            case 'textboxes':
            case 'geocoders':
              firstInvalidId = Math.max(...question.items.map((q) => q.id)) + 1;
              this.clearExtraAnswersForGroup(question, surveyData, '_', firstInvalidId);
              break;
            case 'selects':
              firstInvalidId = Math.max(...question.questions.map((q) => q.id)) + 1;
              this.clearExtraAnswersForGroup(question, surveyData, '_', firstInvalidId);
              break;
            case 'vehicles':
              firstInvalidId = Math.max(...question.questions.map((q) => q.id)) + 1;
              this.clearVehicles(question, surveyData, firstInvalidId);
              break;
            case 'checkbox':
              firstInvalidId = Math.max(...question.items.map((q) => q.id)) + 1;
              this.clearExtraAnswersForGroup(question, surveyData, '_', firstInvalidId, '_CB_');
              break;
          }
        } else if (question.type === 'textboxes') {
          for (i = 0, max = question.params.maxEntries; i < max; i++) {
            field = question.name + '_' + i;
            if (surveyData[field] === '') {
              surveyData[field] = null;
            }
          }
        }
        return Promise.resolve();
      })
    );
  }
}
